export const style = {
  scrollContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    gap: "1rem",
    flexWrap: "nowrap",
    overflow: "scroll",
    "&::-webkit-scrollbar": { display: "none" },
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  },
  clearBtn: {
    borderRadius: "1.8rem",
    background: "var(--gray-500)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.8rem 1.2rem",
    width: "max-content",
    cursor: "pointer",
  },
  clearText: {
    marginLeft: "0.4rem",
    color: "var(--neutral-100)",
    fontSize: "1.2rem",
    fontWeight: 400,
    textTransform: "capitalize",
  },
};
